import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "filterCount",
    "filterBody"
  ]

  connect () {
    this.refreshFilterCount()
  }

  refreshFilterCount () {
    const selectedFiltersNotPrompt = this.filterBodyTarget.querySelectorAll("input[type='checkbox']:checked[value]:not([value='on']), input[type='radio']:checked[value]:not([value='on'])")

    if (selectedFiltersNotPrompt.length > 0) {
      this.filterCountTarget.classList.remove("d-none")
      this.filterCountTarget.textContent = selectedFiltersNotPrompt.length
    } else {
      this.filterCountTarget.textContent = ""
      this.filterCountTarget.classList.add("d-none")
    }
  }

  syncUrl (event) {
    if (!event.detail?.success) return

    const form = this.element
    if (!(form instanceof HTMLFormElement)) return
    if (form.method.toUpperCase() !== "GET") return

    const url = new URL(form.getAttribute("action") || window.location.pathname, window.location.origin)
    url.search = new URLSearchParams(new FormData(form)).toString()

    const nextUrl = `${url.pathname}${url.search}`
    const currentUrl = `${window.location.pathname}${window.location.search}`
    if (nextUrl === currentUrl) return

    history.pushState({}, "", nextUrl)
  }
}
